'use client';
import { useState } from 'react';
import { ecomercePlatfromList } from '../_config';

const brandAccent = {
    amazon:   { color: '#FF9900', glow: 'rgba(255,153,0,0.5)',  light: 'rgba(255,153,0,0.1)',  label: 'Shop on Amazon'   },
    flipkart: { color: '#2874F0', glow: 'rgba(40,116,240,0.5)', light: 'rgba(40,116,240,0.1)', label: 'Shop on Flipkart' },
};
const fallback = { color: '#1bb8a7', glow: 'rgba(27,184,167,0.5)', light: 'rgba(27,184,167,0.1)', label: 'Shop Now' };

const trustItems = [
    { icon: 'pi-shield',   text: '100% Genuine'   },
    { icon: 'pi-truck',    text: 'Fast Delivery'   },
    { icon: 'pi-refresh',  text: 'Easy Returns'    },
    { icon: 'pi-lock',     text: 'Secure Checkout' },
];

/* floating e-commerce icons scattered across the background */
const floatingIcons = [
    { icon: 'pi-shopping-cart',  top: '12%',  left: '4%',   size: '1.4rem', opacity: 0.18, dur: '9s',  delay: '0s'    },
    { icon: 'pi-truck',          top: '72%',  left: '7%',   size: '1.2rem', opacity: 0.14, dur: '12s', delay: '2s'    },
    { icon: 'pi-box',            top: '38%',  left: '1%',   size: '1rem',   opacity: 0.12, dur: '15s', delay: '5s'    },
    { icon: 'pi-tag',            top: '85%',  left: '18%',  size: '1.1rem', opacity: 0.15, dur: '10s', delay: '1s'    },
    { icon: 'pi-star',           top: '20%',  left: '22%',  size: '0.9rem', opacity: 0.10, dur: '13s', delay: '3.5s'  },
    { icon: 'pi-credit-card',    top: '60%',  left: '25%',  size: '1.2rem', opacity: 0.13, dur: '11s', delay: '0.5s'  },
    { icon: 'pi-qrcode',         top: '5%',   left: '42%',  size: '1rem',   opacity: 0.10, dur: '16s', delay: '4s'    },
    { icon: 'pi-receipt',        top: '90%',  left: '45%',  size: '1.1rem', opacity: 0.13, dur: '14s', delay: '6s'    },
    { icon: 'pi-map-marker',     top: '48%',  left: '48%',  size: '1rem',   opacity: 0.09, dur: '18s', delay: '2.5s'  },
    { icon: 'pi-gift',           top: '15%',  left: '70%',  size: '1.3rem', opacity: 0.15, dur: '10s', delay: '1.5s'  },
    { icon: 'pi-verified',       top: '78%',  left: '72%',  size: '1rem',   opacity: 0.12, dur: '13s', delay: '7s'    },
    { icon: 'pi-refresh',        top: '32%',  left: '80%',  size: '1.1rem', opacity: 0.13, dur: '11s', delay: '3s'    },
    { icon: 'pi-send',           top: '55%',  left: '88%',  size: '1rem',   opacity: 0.10, dur: '15s', delay: '0.8s'  },
    { icon: 'pi-wallet',         top: '8%',   left: '93%',  size: '1.2rem', opacity: 0.14, dur: '9s',  delay: '4.5s'  },
    { icon: 'pi-check-circle',   top: '92%',  left: '90%',  size: '0.9rem', opacity: 0.11, dur: '12s', delay: '2s'    },
];

const CSS = `
@keyframes plt-float {
    0%   { transform: translateY(0px)   rotate(0deg);   }
    33%  { transform: translateY(-14px) rotate(4deg);   }
    66%  { transform: translateY(6px)   rotate(-3deg);  }
    100% { transform: translateY(0px)   rotate(0deg);   }
}
@keyframes plt-drift {
    0%   { transform: translateY(0px)  translateX(0px);   }
    25%  { transform: translateY(-10px) translateX(6px);  }
    50%  { transform: translateY(-4px)  translateX(-8px); }
    75%  { transform: translateY(8px)   translateX(4px);  }
    100% { transform: translateY(0px)  translateX(0px);   }
}
`;

export const PlatfromAvilable = () => {
    const [hovered, setHovered] = useState(null);

    return (
        <section style={{ position: 'relative', overflow: 'hidden', borderRadius: 16 }}>
            <style>{CSS}</style>

            {/* ── Solid dark background ───────────────────────────────────── */}
            <div style={{
                position: 'absolute', inset: 0,
                background: 'linear-gradient(135deg, #0b1f3a 0%, #0b3163 55%, #0d2a5a 100%)',
            }} />

            {/* ── Soft radial glows ───────────────────────────────────────── */}
            <div style={{ position: 'absolute', top: '-20%', left: '-10%', width: '55%', height: '140%', background: 'radial-gradient(ellipse, rgba(255,153,0,0.08) 0%, transparent 65%)', pointerEvents: 'none' }} />
            <div style={{ position: 'absolute', top: '-20%', right: '-10%', width: '55%', height: '140%', background: 'radial-gradient(ellipse, rgba(40,116,240,0.10) 0%, transparent 65%)', pointerEvents: 'none' }} />

            {/* ── Floating e-commerce icons ───────────────────────────────── */}
            {floatingIcons.map((item, i) => (
                <i
                    key={i}
                    className={`pi ${item.icon}`}
                    style={{
                        position: 'absolute',
                        top: item.top, left: item.left,
                        fontSize: item.size,
                        color: '#ffffff',
                        opacity: item.opacity,
                        pointerEvents: 'none',
                        animation: `${i % 2 === 0 ? 'plt-float' : 'plt-drift'} ${item.dur} ease-in-out ${item.delay} infinite`,
                    }}
                />
            ))}

            {/* ── Content ────────────────────────────────────────────────── */}
            <div style={{ position: 'relative', zIndex: 1, padding: 'clamp(2rem, 5vw, 3.5rem) clamp(1rem, 4vw, 3rem)' }}>

                {/* ── Top label ──────────────────────────────────────────── */}
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1.25rem' }}>
                    <span style={{
                        display: 'inline-flex', alignItems: 'center', gap: '0.4rem',
                        background: 'rgba(255,255,255,0.08)',
                        border: '1px solid rgba(255,255,255,0.18)',
                        color: '#c8d8f0',
                        fontSize: '0.68rem', fontWeight: 700,
                        letterSpacing: '1.8px', textTransform: 'uppercase',
                        padding: '5px 16px', borderRadius: 999,
                        backdropFilter: 'blur(8px)',
                    }}>
                        <i className="pi pi-verified" style={{ fontSize: '0.65rem', color: '#60a5fa' }} />
                        Official Stores
                    </span>
                </div>

                {/* ── Heading ────────────────────────────────────────────── */}
                <h2 style={{
                    textAlign: 'center', margin: '0 0 0.75rem',
                    fontSize: 'clamp(1.5rem, 3.5vw, 2.2rem)',
                    fontWeight: 800, lineHeight: 1.2,
                    color: '#ffffff',
                    letterSpacing: '-0.01em',
                }}>
                    Available on{' '}
                    <span style={{
                        background: 'linear-gradient(90deg, #FF9900 0%, #2874F0 100%)',
                        WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                    }}>
                        Leading Platforms
                    </span>
                </h2>

                <p style={{
                    textAlign: 'center', margin: '0 auto 2.5rem',
                    color: 'rgba(200,216,240,0.75)',
                    fontSize: '0.88rem', lineHeight: 1.7,
                    maxWidth: '34rem',
                }}>
                    Shop Ennix products from your favourite marketplace — fast delivery, easy returns &amp; genuine products guaranteed.
                </p>

                {/* ── Platform cards ─────────────────────────────────────── */}
                <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '1.25rem' }}>
                    {Object.keys(ecomercePlatfromList).map((key) => {
                        const item   = ecomercePlatfromList[key];
                        const accent = brandAccent[key] ?? fallback;
                        const isHov  = hovered === key;

                        return (
                            <a
                                key={item.id}
                                href={item.url}
                                target="_blank"
                                rel="noreferrer"
                                onMouseEnter={() => setHovered(key)}
                                onMouseLeave={() => setHovered(null)}
                                style={{
                                    display: 'flex', flexDirection: 'column', alignItems: 'center',
                                    gap: '1rem',
                                    padding: '1.5rem 1.75rem',
                                    borderRadius: 16,
                                    border: `1.5px solid ${isHov ? accent.color : 'rgba(255,255,255,0.12)'}`,
                                    background: isHov
                                        ? `linear-gradient(145deg, ${accent.light}, rgba(255,255,255,0.06))`
                                        : 'rgba(255,255,255,0.05)',
                                    backdropFilter: 'blur(12px)',
                                    boxShadow: isHov
                                        ? `0 0 0 1px ${accent.color}33, 0 16px 48px ${accent.glow}, 0 4px 16px rgba(0,0,0,0.3)`
                                        : '0 4px 24px rgba(0,0,0,0.2)',
                                    textDecoration: 'none',
                                    cursor: 'pointer',
                                    transition: 'all 0.25s ease',
                                    transform: isHov ? 'translateY(-6px) scale(1.03)' : 'none',
                                    minWidth: 190, flex: '1 1 180px', maxWidth: 240,
                                }}
                            >
                                {/* Logo container */}
                                <div style={{
                                    width: '100%', height: 44,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    background: 'rgb(255,255,255)',
                                    borderRadius: 10,
                                    padding: '0 1rem',
                                    transition: 'background 0.25s',
                                    boxShadow: isHov ? `0 0 0 2px ${accent.color}55` : 'none',
                                }}>
                                    {/* eslint-disable-next-line @next/next/no-img-element */}
                                    <img
                                        src={item.logo}
                                        alt={item.title}
                                        style={{ height: 28, width: '100%', objectFit: 'contain' }}
                                    />
                                </div>

                                {/* Platform name */}
                                <span style={{
                                    fontSize: '0.72rem', fontWeight: 700,
                                    color: isHov ? accent.color : 'rgba(200,216,240,0.6)',
                                    letterSpacing: '1px', textTransform: 'uppercase',
                                    transition: 'color 0.25s',
                                }}>
                                    {item.title}
                                </span>

                                {/* CTA */}
                                <span style={{
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.4rem',
                                    width: '100%', padding: '9px 0', borderRadius: 999,
                                    background: isHov ? accent.color : 'rgba(255,255,255,0.1)',
                                    color: '#fff',
                                    fontSize: '0.8rem', fontWeight: 700,
                                    letterSpacing: '0.3px',
                                    transition: 'all 0.25s',
                                    boxShadow: isHov ? `0 4px 16px ${accent.glow}` : 'none',
                                }}>
                                    {accent.label}
                                    <i className="pi pi-arrow-right" style={{
                                        fontSize: '0.65rem',
                                        transform: isHov ? 'translateX(3px)' : 'none',
                                        transition: 'transform 0.25s',
                                    }} />
                                </span>
                            </a>
                        );
                    })}
                </div>

                {/* ── Trust strip ────────────────────────────────────────── */}
                <div style={{
                    display: 'flex', justifyContent: 'center', flexWrap: 'wrap',
                    gap: '0.5rem 1.75rem', marginTop: '2.5rem',
                }}>
                    {trustItems.map(({ icon, text }) => (
                        <div key={text} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                            <i className={`pi ${icon}`} style={{ fontSize: '0.72rem', color: '#60a5fa' }} />
                            <span style={{ fontSize: '0.75rem', fontWeight: 600, color: 'rgba(200,216,240,0.7)' }}>{text}</span>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};
